import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { getC3ExportsColumns, TC3Export } from "./columns";
import {
  type FilterC3ExportsSchemaType,
  FilterC3Exports,
} from "./filter";

const client = "c3";
const table_name = "c3_exports";

export const C3ExportsTable = () => {
  const { t, i18n } = useTranslation();
  const columns = useMemo(() => getC3ExportsColumns(t), [t, i18n.language]);

  return (
    <Table<TC3Export, FilterC3ExportsSchemaType>
      label={t("download_center.title", { defaultValue: "Download Center" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterC3Exports />}
      download_button={false}
      disable_translations_request={true}
      columnVisibilityInit={{
        id: false,
      }}
    />
  );
};
